export const state = {
	dataLoader: true
}

export const mutations = {
	toggleDataLoader(state){
		state.dataLoader = !state.dataLoader;
	}
}

export const actions = {
	toggleLoader({commit}){
		commit('toggleDataLoader');
	}
}

export const getters = {
	dataLoader: state => {
		return state.dataLoader;
	}
}